export class FileUploadInput {

    constructor(target = '.js-file', options = {}) {

        this.target = target;

        this.options = {
            ...options
        }
    }

    init() {
        this.files = Array.from(document.querySelectorAll(this.target));
        if(!this.files) {
            return false
        }
        this.files.forEach( container => {
            const input = container.querySelector('.js-file__input');
            const textField = container.querySelector('.js-file__text');
            input.addEventListener( 'change', () => {
                const fileName = input.value.replace( 'C:\\fakepath\\', '' ).replace( ' ', '-' );
                textField.value = fileName;
            })
        })
    }
}
